export default {
  "content": "<path d=\"M11.531 1.116a1 1 0 011.079.09l6.5 5c.246.19.39.483.39.794v3h-2V7.49L12 3.261 6.5 7.49V19H10v2H5.5a1 1 0 01-1-1V7c0-.31.145-.604.39-.793l6.5-5 .141-.09z\" fill=\"#7B61FF\"/><path d=\"M20.56 13.162l-2.587 3.622h1.773v2H17.03v.973h2.716v2H17.03v1.973h-2v-1.973h-2.716v-2h2.716v-.973h-2.716v-2h1.773L11.5 13.162 13.127 12l2.902 4.063L18.933 12l1.627 1.162zM12 10a1.5 1.5 0 110-3 1.5 1.5 0 010 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};